export default __webpack_public_path__ + "static/media/preview-blue.56838cde.svg";